export const URL_API_AUTENTICACION_V2_VU = {
    /**
     * Obtener Configuracion (v2) - VU.
    */
    CONFIGURACION: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Configuracion/GetVu_Info`,
    
    /**
     * Validar Token VU
    */
    VALIDAR_TOKEN: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/ValidarTokenVU`,
    
    /**
     * Guardar Resultado VU
    */
    GUARDAR_RESULTADO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Contactos/GuardarValidacionVU`,
    /**
     * Generar Enlace Prueba de Vida VU
     */
    GENERAR_ENLACE_PRUEBA_VIDA: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/GenerarEnlacePruebaVida`,
    /**
     * Cambio de correo electrónico VU
     */
    CAMBIO_CORREO_ELECTRONICO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/cambio-correo-electronico`
}